// ── ui.js — UI 고정 문구 한→중 사전 (V105) ────────────────────────────────
//
// 키가 곧 한국어 원문이다. 문자열 ID를 새로 만들지 않는 이유:
//   1) 기존 코드를 t('단가표')로 감싸기만 하면 된다 (140개 파일 재설계 불필요)
//   2) 사전에 없는 문장은 자동으로 한국어가 그대로 나온다 → 중간에 멈춰도 안 깨짐
//
// 범위: 중국 직원이 권한을 갖는 화면.
//   상단 탭 · 단가표 · 발주서 · 재고관리 · 식재료
// 세무/인건비/공동구매/관리자/랜딩은 매니저 권한에서 숨겨지므로 대상 아님.
//
// 표기: 중국 대륙 간체자. 주방·매장에서 실제로 통하는 말 우선.

export const UI_ZH = {
  // ── 상단 탭 ──────────────────────────────────────────────────────────
  '홈': '首页',
  '레시피': '配方',
  '오늘의 작업': '今日工作',   // V149
  '단체주문': '团体订单',
  '발주서': '订货单',
  '입고': '入库',   // V158
  '계정과목': '会计科目',   // V159
  '단가표': '单价表',
  '운영': '运营',
  '식재료': '食材',
  '공동구매': '团购',
  '재고관리': '库存管理',
  '인건비': '人工费',
  '세무회계': '税务会计',
  '매장 안내서': '门店手册',
  '설정': '设置',
  '도움말': '帮助',
  '로그아웃': '退出登录',

  // ── 공통 동작 ────────────────────────────────────────────────────────
  '저장': '保存',
  '취소': '取消',
  '삭제': '删除',
  '수정': '修改',
  '편집': '编辑',
  '추가': '添加',
  '검색': '搜索',
  '확인': '确认',
  '닫기': '关闭',
  '닫기 ✕': '关闭 ✕',
  '전체': '全部',
  '인쇄': '打印',
  '조회': '查询',
  '초기화': '重置',
  '필터 초기화': '重置筛选',
  '내보내기': '导出',
  '불러오기': '导入',
  '새로고침': '刷新',
  '돌아가기': '返回',
  '다음': '下一步',
  '이전': '上一步',
  '완료': '完成',
  '적용': '应用',
  '현재': '当前',
  '미입력': '未填写',

  // ── 단가표 ───────────────────────────────────────────────────────────
  '단가표 관리': '单价表管理',
  '+ 항목 추가': '+ 添加品项',
  '품목 추가': '添加品项',
  '中 중국어 일괄': '中 批量生成中文',
  '코드': '编号',
  '재료명': '食材名称',
  '재료명 *': '食材名称 *',
  '구분': '分类',
  '업체': '供应商',
  '업체명': '供应商名称',
  '업체 미지정': '未指定供应商',
  '규격': '规格',
  '단위': '单位',
  '단가 (원)': '单价 (韩元)',
  '단가 (¥)': '单价 (元)',
  '매장 국가': '门店所在国',
  '한국': '韩国',
  '중국': '中国',
  '단가 *': '单价 *',
  '기준량 (g)': '基准量 (g)',
  '기준량': '基准量',
  '기준량(g)': '基准量(g)',
  '내 평균가 (30일)': '我的均价 (30天)',
  '시장가 (도매·kg)': '市场价 (批发·kg)',
  '네이버 최저가': 'Naver 最低价',
  '관리': '操作',
  '신선식품': '生鲜',
  '공산품': '干货',
  '소모품': '消耗品',
  '반제품': '半成品',
  '원재료': '原材料',
  '중국어': '中文',
  '중국어명': '中文名称',
  '재료명 또는 코드 검색...': '搜索食材名称或编号...',
  '재료명을 입력해주세요': '请输入食材名称',
  '단가를 입력해주세요': '请输入单价',
  '이 단가 항목을 삭제하시겠습니까?': '确定要删除该单价项目吗？',
  '다른 화면에서 이 품목이 바뀌었어요. 다시 열어 수정해주세요.': '该品目已在其他页面被修改，请重新打开后再编辑。',   // V121
  '한글로 바꾸기': '转为韩文',   // V122
  '못 채운 것': '未能填写',   // V122
  '기준량 원가': '基准量成本',   // V124
  '무료': '免费',   // V125
  '끌어서 순서 바꾸기': '拖动调整顺序',   // V129
  '배수': '倍数',   // V130
  '원래대로': '恢复原样',
  '수량 1 = 규격만큼': '数量1 = 一个规格',   // V135
  '이 매장의 국가가 ‘한국’으로 되어 있어요': '本店的门店所在国目前是“韩国”',   // V136
  '그래서 금액이 원으로 나오고, 수량 1 = 규격만큼(예: 10근) 발주와 중국어 발주서가 꺼져 있어요. 중국 매장이면 바꿔 주세요.': '所以金额显示为韩元（원），也没有开启“数量1 = 一个规格（例：10斤）”订货。如果是中国门店，请改为中国。',
  '중국 매장으로 바꾸기': '改为中国门店',
  '나중에': '以后再说',
  // V137 발주서 따로 저장·합치기
  '저장하면 발주서가 비워져요. 다음 발주(추가 발주)는 새 발주서로 따로 저장돼요.': '保存后订货单会清空。下一次（追加）订货会另存为新的订货单。',
  '아직 안 보냈다면 먼저 📤 전송·🖨 인쇄를 하세요. 저장한 발주서도 📅 내역에서 다시 보낼 수 있어요.': '如果还没发送，请先 📤 发送·🖨 打印。已保存的订货单也可以在 📅 记录 里再次发送。',
  '발주서를 저장하고 비웠어요': '订货单已保存并清空',
  '추가 발주는 새로 담아서 저장하면 따로 저장돼요. 하나로 묶으려면 📅 내역에서 골라 🔗 합치기.': '追加订货重新选好后保存，会另存一张。想合成一张，请在 📅 记录 里勾选后 🔗 合并。',
  '내역 보기': '查看记录',
  '품목': '项',
  '합칠 발주서로 고르기': '选择要合并的订货单',
  '개 합침': '张合并',
  '같은 날 따로 저장한 발주서는 ☑ 골라서 하나로 합칠 수 있어요': '同一天分开保存的订货单，可以 ☑ 勾选后合并成一张',
  '개 선택': '张已选',
  '다른 달 발주서는 합칠 수 없어요 (월 정산 금액이 바뀌어요)': '不同月份的订货单不能合并（会改变月度结算金额）',
  '2개 이상 고르세요': '请选择两张以上',
  '합치기': '合并',
  '선택 해제': '取消选择',
  '복사됐어요': '已复制',
  '보냈어요': '已发送',
  '위챗 글 복사': '复制微信文字',
  '글 복사': '复制文字',
  // V138 발주처별 저장·수량 고치기
  '발주처별로 발주서가 따로 저장되고, 발주서는 비워져요. 추가 발주는 새 발주서로 따로 저장돼요.': '订货单会按供应商分开保存，保存后清空。追加订货会另存为新的订货单。',
  '고침': '已修改',
  '수량 고치기': '修改数量',
  '수량을 바꾸고 저장하세요. 0이면 그 품목을 빼요.': '改好数量后保存。0 = 删除该项。',
  '고친 내용 저장': '保存修改',
  '이 품목 빼기': '删除该项',
  '것만 복사·엑셀·PDF로 나가요': '的部分会被复制、导出Excel·PDF',   // V139
  '반제품 레시피를 찾을 수 없어요 (이름이 바뀌었나요?)': '找不到这个半成品配方（是不是改过名字？）',   // V141
  '반제품 고르기': '选择半成品',
  '이 반제품으로 연결': '连接到这个半成品',
  '💬 업체 문의 목록': '💬 询价清单',   // V143
  '고른 발주처의 품목을 위챗으로 다른 업체에 물어볼 목록으로 만들어요 (가격 없음)': '把所选供应商的食材整理成询价清单发微信（不含价格）',
  '이름': '名称',
  '단가표에 항목을 먼저 등록하세요.': '请先在单价表中登记品项。',
  '단가표에 식재료를 등록하세요': '请先在单价表中登记食材',
  '모든 품목에 이미 중국어명이 있습니다.': '所有品项已有中文名称。',
  '단위 환산 불가': '无法换算单位',
  '조회 완료': '查询完成',

  // ── 발주서 ───────────────────────────────────────────────────────────
  '원재료 목록': '原材料列表',
  '발주': '订货',
  '발주 수량': '订货数量',
  '발주서 저장': '保存订货单',
  '발주서가 비어있어요.': '订货单是空的。',
  '왼쪽에서 재료를 검색하고 추가하세요': '请在左侧搜索并添加食材',
  '검색 결과 없음': '没有搜索结果',
  '메모': '备注',
  '메모 (선택)': '备注 (可选)',
  '날짜': '日期',
  '품목 수': '品项数',
  '합계 금액': '合计金额',
  '합계': '合计',
  '금액': '金额',
  '수량': '数量',
  '엑셀 다운로드': '下载 Excel',
  '엑셀 다운로드 (.xlsx)': '下载 Excel (.xlsx)',
  'PDF 저장': '保存 PDF',
  'PDF·인쇄': 'PDF·打印',
  '표 복사 (붙여넣기용)': '复制表格 (粘贴用)',
  '파일로 저장하거나 인쇄하세요': '保存为文件或打印',
  '저장된 발주 내역이 없어요': '没有已保存的订货记录',
  '조건에 맞는 내역이 없어요': '没有符合条件的记录',
  '연락처': '联系人',
  '+ 연락처 추가': '+ 添加联系人',
  '저장된 연락처가 없어요': '没有已保存的联系人',
  '이름을 입력해주세요': '请输入名称',
  '사업자 이름 입력': '请输入商号名称',
  '안전재고': '安全库存',
  '(제외)': '(排除)',

  // ── 재고관리 ─────────────────────────────────────────────────────────
  '재고': '库存',
  '현재고': '现有库存',
  '적정재고': '安全库存',
  '발주 필요': '需要订货',
  '주의': '注意',
  '충분': '充足',
  '부족': '不足',
  '데이터 없음': '暂无数据',
  '상태순': '按状态',
  '소진일순': '按耗尽日',
  '이름순': '按名称',
  '발주표 보기': '查看订货表',
  '+ 발주': '+ 订货',
  '✅ 충분': '✅ 充足',
  '추천 발주량 일괄 추가': '批量添加推荐订货量',
  '사용량 데이터가 없어요': '没有用量数据',
  '입고': '入库',
  '출고': '出库',
  '실사': '盘点',
  '유통기한': '保质期',
  '거래처': '供应商',

  // ── 식재료 ───────────────────────────────────────────────────────────
  '매입': '采购',
  '매출': '营业额',
  '원가': '成本',
  '판매가': '售价',
  '마진율': '利润率',

  // ── 레시피 (일부) ────────────────────────────────────────────────────
  '메뉴': '菜单',
  '재료': '食材',
  '사용량': '用量',
  '인분': '人份',
  '1인분': '一人份',
  '새 레시피': '新配方',
  '조리법': '做法',

  // ── 상태 메시지 ──────────────────────────────────────────────────────
  '저장되었습니다': '已保存',
  '불러오는 중...': '加载中...',
  '데이터가 없습니다': '暂无数据',
  '검색 결과가 없습니다': '没有搜索结果',
  '번역 중...': '翻译中...',
  '오프라인 상태입니다': '当前处于离线状态',
  '표시 언어': '显示语言',
  // ── 레시피 (V109) ───────────────────────────────────────────────────
  '목록으로': '返回列表',
  '주방용 인쇄': '厨房打印',
  '주방 벽에 붙이는 한중 병기 레시피 (원가 제외)': '打印贴在厨房的中韩对照配方（不含成本）',
  '판매 메뉴': '售卖菜品',
  '1인분 원가': '每份成本',
  '1인분 이익': '每份利润',
  '총 생산량': '总产量',
  '판매가 분석 (1인분 기준)': '售价分析（按1人份）',
  '편집에서 판매가격을 입력하세요': '请在编辑中输入售价',
  '판매가격': '售价',
  '원재료율': '原料成本率',
  '양호': '良好',
  '위험': '危险',
  '원가율 시뮬레이터': '成本率模拟',
  '등록 단가': '登记单价',
  '목표 원가율': '目标成本率',
  '권장 판매가': '建议售价',
  '식재료 목록': '食材清单',
  '식재료명': '食材名称',
  '단가': '单价',
  '비중': '占比',
  '단가 없음': '无单价',
  '왼쪽에서 레시피를 선택하세요': '请在左侧选择配方',
  '전체 레시피': '全部配方',
  '전체 레시피 인쇄': '打印全部配方',
  '중국어 일괄 채우기': '批量填写中文',
  '모든 레시피에 중국어가 있습니다': '所有配方都已有中文',
  '중국어 채움': '已填写中文',
  '번역 실패 — 네트워크를 확인하세요': '翻译失败 — 请检查网络',
  '팝업이 차단되었습니다. 팝업을 허용해주세요': '弹出窗口被拦截，请允许弹出窗口',
  '새 레시피 추가': '新增配方',
  '레시피 편집': '编辑配方',
  '조리 메모': '制作备注',
  '비워두면 저장 후 자동 번역': '留空则保存后自动翻译',
  // ── 단체주문·레시피 목록 (V111) ─────────────────────────────────────────
  '텍스트 복사': '复制文本',
  '발주서에 추가됨!': '已加入订货单！',
  '발주서에 추가': '加入订货单',
  '주문 구성': '订单构成',
  '사용 메뉴': '使用菜品',
  '필요량': '需要量',
  '발주수량': '订货数量',
  '레시피 선택': '选择配方',
  '메뉴 선택': '选择菜品',
  '인분 수를 입력하세요': '请输入份数',
  '발주서 보기': '查看订货单',
  '레시피 선택으로': '返回选择配方',
  '왼쪽 탭에서 메뉴를 선택하세요': '请在左侧标签中选择菜品',
  '왼쪽에서 메뉴와 인분 수를 선택하세요': '请在左侧选择菜品和份数',
  '선택하면 자재 발주서가 자동 생성돼요': '选择后会自动生成材料订货单',
  '원재료 분해 발주서': '原材料分解订货单',
  '반제품을 원재료로 분해한 발주서입니다. 위 발주서와 비교하여 사용하세요.': '这是把半成品拆分成原材料的订货单，请与上面的订货单对照使用。',
  // ── 단가표 열·업체 (V112) ────────────────────────────────────────────
  '제조사': '生产厂家',
  '발주처': '供应商',
  '발주처 미지정': '未指定供应商',
  '항목이 없습니다': '暂无项目',
  '클릭하여 수정 (Enter=저장, Esc=취소)': '点击修改（Enter=保存，Esc=取消）',
  '코드 (비우면 자동)': '编号（留空自动）',
  // ── 레시피 편집 (V114) ─────────────────────────────────────────────────
  '메뉴 이름': '菜品名称',
  '유형': '类型',
  '카테고리': '类别',
  '예: 떡볶이 소스': '例：炒年糕酱汁',
  '재료명 입력 (단가표 자동검색)': '输入食材名（自动搜索单价表）',
  '연동': '已关联',
  '단가표에 항목은 있으나 가격/용량 미입력 — 단가표 화면에서 채워주세요': '单价表中有此项，但未填写价格/基准量 — 请到单价表补充',
  '단가표 미매칭 — 이름을 단가표 항목과 일치시키거나 단가표에 먼저 등록하세요': '单价表中没有此项 — 请改成与单价表一致的名称，或先在单价表登记',
  '식재료 합계': '食材合计',
  '단가 매칭': '单价匹配',
  '중량': '重量',
  '총생산량 대비': '对比总产量',
  '1인분 약': '每份约',
  '식재료 추가': '添加食材',
  '분량 정보': '份量信息',
  '총 생산량 (g)': '总产量 (g)',
  '정말 삭제하시겠습니까?': '确定要删除吗？',
  '레시피 이름을 입력해주세요': '请输入配方名称',
  '카테고리를 선택해주세요': '请选择类别',
  '재료를 최소 1개 이상 입력해주세요': '请至少输入一种食材',
  // ── 새 카테고리 (V115) ─────────────────────────────────────────────────
  '➕ 새 카테고리 만들기': '➕ 新建类别',
  '새 카테고리 이름 (예: 소스 / 양념)': '新类别名称（例：酱汁/调料）',
  '아직 카테고리가 없어요. 이름을 입력하면 새로 만들어집니다.': '还没有类别，输入名称即可新建。',
  '새 카테고리 이름을 입력해주세요': '请输入新类别名称',
  // ── 단가표 구매 링크·버튼 (V118) ─────────────────────────────────────────
  '구매 링크': '购买链接',
  '링크 붙여넣기': '粘贴链接',
  '열기': '打开',
  '링크 아님': '不是链接',
  '클릭해서 구매 페이지 열기': '点击打开购买页面',
  '비워두면 자동': '留空自动',
  '중국어명이 비어 있는 품목을 한 번에 채웁니다 (직접 고친 건 유지)': '一次性补全缺少中文的品项（保留手动修改）',
  '단가표 전체를 엑셀로 저장': '把整个单价表保存为Excel',
  '📥 엑셀': '📥 Excel',
  '시장가 + 네이버 + AI 매칭을 한 번에 자동 실행 (미매칭만 AI 호출)': '一键查询市场价+Naver+AI匹配（仅未匹配项用AI）',
  '💎 시장 가격 자동 조회': '💎 自动查询市场价',
  '개별 조회': '单项查询',
  '네이버 쇼핑 최저가 일괄 조회 (캐시 6시간)': '批量查询Naver购物最低价（缓存6小时）',
  '⏳ 조회 중...': '⏳ 查询中...',
  '🔄 네이버 다시': '🔄 重新查询Naver',
  '🛒 네이버만': '🛒 仅Naver',
  '시장가·네이버 매칭 안 된 항목을 Claude Haiku로 표준명 추정': '对未匹配市场价·Naver的品项用AI推测标准名称',
  '🤖 AI만': '🤖 仅AI',
  '🏷 거래처 미지정': '🏷 未指定供应商',

  // ── V147: 분류 (발주서·재고에서 t(분류)로 보여준다) ─────────────────────────────
  '미분류': '未分类',
  '기타': '其他',
};

/**
 * @param {string} ko 한국어 원문
 * @param {'ko'|'zh'} lang
 * @returns {string} 해당 언어 문구 (없으면 한국어 원문)
 */
export function tr(ko, lang) {
  if (lang !== 'zh') return ko;
  if (typeof ko !== 'string') return ko;
  return UI_ZH[ko] || UI_ZH[ko.trim()] || ko;
}

export const UI_ZH_SIZE = Object.keys(UI_ZH).length;
